import { render, staticRenderFns } from "./WidgetLinkElement.vue?vue&type=template&id=064a292c&scoped=true"
import script from "./WidgetLinkElement.vue?vue&type=script&lang=js"
export * from "./WidgetLinkElement.vue?vue&type=script&lang=js"
import style0 from "./WidgetLinkElement.vue?vue&type=style&index=0&id=064a292c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064a292c",
  null
  
)

export default component.exports